import Phaser from 'phaser';

export default class Ornament extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, key) {
    super(scene, x, y, key);

    this.scene.add.existing(this);
  }
}

export function preload(key, asset) {
  this.load.image(key, `ornaments/${asset}`);
}
